//Angular
import {Component, Inject, OnInit, ViewEncapsulation} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";

//Models
import { CategoryProductDTO } from "../../../../model/club-gigot/inventory-points/product-category/category-product.dto";

//Services
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { BehaviorSubject } from "rxjs";
import { CatalogService } from "../../../../service/club-gigot/catalog.service";

@Component({
  selector: 'cg-dialog-category',
  templateUrl: './dialog-category-product-cg.component.html',
  styleUrls: ['./dialog-category-product-cg.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DialogCategoryProductComponent implements OnInit {

    public actionPointCategoryForm : FormGroup;
    public _isEditMode : boolean = false;

    public loading$ = new BehaviorSubject(true);
    public error = new BehaviorSubject('');

    public maxCampaignDelay : number = 15;

    constructor( private dialogRef: MatDialogRef<DialogCategoryProductComponent>,
                 private catalogService : CatalogService,
                 @Inject(MAT_DIALOG_DATA)
                 public data: CategoryProductData
    ) { }

    public ngOnInit() : void {
        this.buildForm();
        this.loading$.next(false)
    }

    public buildForm(){
        if(this.data.entity)
            this._isEditMode = true;
        
        this.actionPointCategoryForm = new FormGroup({
            id : new FormControl(this._isEditMode ? this.data.entity.id : null),
            name: new FormControl(this._isEditMode ? this.data.entity.name : null, [Validators.required]),
            campaignsDelay: new FormControl(this._isEditMode ? this.data.entity.campaignsDelay.toString() : null, [Validators.required]),
        })
    }

    public onNoClick(): void {
        this.dialogRef.close();
    }

    public onSaveCategory() : void {
        this.catalogService.saveCatalogCategory(this.data.campaignSequence, this.actionPointCategoryForm.value)
            .subscribe({
                next : (_ : any) => this.dialogRef.close(),
                error : (error : Error) => this.error.next("Error. Intentelo de nuevo o llame a sistemas")
            })
    }
}

export class CategoryProductData {
    public entity : CategoryProductDTO;
    public campaignSequence : number;

    constructor(entity : CategoryProductDTO, campaignSequence: number){
        this.entity = entity;
        this.campaignSequence = campaignSequence;
    }
}
